import 'animate.css';
import { useAppGlobStore } from "src/appGlobalStore";
import Logo from "../Logo";
import { SideNavBar } from "../SideNavBar";
import HamburgerMenuButton from "./HamburgerMenuButton";
import "./LeftMenuMobile.less";

const LeftMenuMobile: React.FC = () => {
  const isMobileLeftTreeOpen = useAppGlobStore(s => s.isMobileLeftTreeOpen);

  return (
    <aside className={`left-menu-mobile animate__animated animate__faster ${isMobileLeftTreeOpen ? "animate__slideInLeft" : "animate__slideOutLeft"}`}>
      <div className="logo-header">
        <HamburgerMenuButton openLeftMenu={false} isInLeftMenu />
        <Logo />
      </div>

      <SideNavBar />
    </aside>
  );
};

export default LeftMenuMobile;
